<template>
  <div class="mt-5">
    <v-card tile outlined flat>
      <v-data-table
        :loading="loading"
        class="custom__table"
        :items="items"
        :headers="headers"
      >
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-btn @click="print(item)" depressed class="primary mr-3" tile>
              Print</v-btn
            >
            <complaint :id="item.autono"></complaint>
          </div>
        </template>
        <template v-slot:item.recharge_status="{ item }">
          <status :status="item.recharge_status"></status>
        </template>
        <template v-slot:item.payment_status="{ item }">
          <status :status="item.payment_status"></status>
        </template>
        <template v-slot:item.refund_status="{ item }">
          <status :status="item.refund_status"></status>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import reportService from "../../assets/services/report.service";
import Status from "./Status.vue";
import Complaint from "./Complaint.vue";
import { printReceipt } from "../../assets/js/common";
export default {
  components: { Status, Complaint },
  data() {
    return {
      items: [],
      loading: true,
    };
  },
  computed: {
    headers() {
      let doc = {
        action: "Action",
        service: "Service",
        rechargemobileno: "Recharge Number",
        payer_name: "Player Name",
        qrcode_txid: "Recharge ID",
        recharge_date: "Recharge Date",
        amount: "Recharge Amount",
        recharge_status: "Recharge Status",
        payer_vpa: "Payment From",
        bank_rrn: "Bank Reference No",
        payment_date: "Payment Date",
        payment_amount: "Payment Amount",
        payment_status: "Payment Status",
        refund_transid: "Bank Reference No",
        refund_date: "Refund Date",
        refund_amount: "Refund Amount",
        refund_status: "Refund Status",
      };
      let list = [];
      Object.keys(doc).forEach((value) => {
        let text = doc[value];
        let data = {
          text,
          value,
          divider: true,
        };
        if (value == "refund_status") data.divider = false;
        list.push(data);
      });
      return list;
    },
  },
  methods: {
    print(item) {
      printReceipt(item);
    },
    format(date) {
      if (!date) return "";
      return moment(date, "MM/DD/YYYY hh:mm:ss a").format("DD-MM-YYYY hh:mm a");
    },
    async init() {
      const vm = this;
      try {
        vm.loading = true;
        let { data } = await reportService.recharge();
        if (data.status == "true") {
          vm.items = data.data.map((item) => {
            let { payment_date, recharge_date, refund_date } = item;
            item.recharge_date = vm.format(recharge_date);
            item.payment_date = vm.format(payment_date);
            item.refund_date = vm.format(refund_date);
            return item;
          });
        } else {
          vm.$alert.show(data.message);
        }
        console.log(data);
        vm.loading = false;
      } catch (error) {
        vm.loading = false;
        vm.$alert.show(error.message);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>